module.exports = __webpack_public_path__ + "assets/shape-octagon.6541e07e.svg";